import { ON_COOKIES_CONSENT } from 'constants/lifeCycle'

export const eventConsent = (data = '') => new CustomEvent(ON_COOKIES_CONSENT, { 'detail': data })
